import { Deserializable } from '../_common/deserializable';

export class SpiderSchedule implements Deserializable{
    id: number;
    shortCode: string;
    keyword: string;
    typeView: string;
    country: string;
    fromDateView: string;
    toDateView: string;
    currentDateView: string;
    state: number;
    stateView: string;
    error: string;
    description: string;
    modifiedAt: number;
    createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }

}
